import React, { useState, useEffect, useCallback } from 'react';
import { InputText, DropdownField } from 'components/common/input';
import BaseModalForm from 'components/common/modal/BaseModalForm';
import { useFormHandlers } from 'core/hooks/form/formHandlers';
import { Alert } from 'react-bootstrap';
import { clientTypeOptions } from 'core/constant/SELECT_OPTIONS';
import { MODAL_FORM_ERRORS } from 'core/constant/MODAL_FORM_ERRORS';

const EditClientModal = ({ show, client, handleClose, handleSave, updating, errors, requestError }) => {
  const [formValues, setFormValues] = useState(client);
  const { handleChange } = useFormHandlers(setFormValues);

  useEffect(() => {
    setFormValues(client);
  }, [client]);

  const handleSaveClick = useCallback(() => {
    handleSave({ ...formValues, id: client?.id });
  }, [formValues, client?.id, handleSave]);

  return (
    <BaseModalForm show={show} title={client?.id ? "Editar Cliente" : "Crear Cliente"} handleClose={handleClose} handleSave={handleSaveClick} updating={updating}>
      <div className="row">
        <div className="col-md-6 form-group">
          <InputText
            label="Nombre"
            name="name"
            value={formValues?.name}
            onChange={(e) => handleChange('name', e.target.value)}
            placeholder="Ingrese el nombre"
            error={errors.name}
          />
        </div>
        <div className="col-md-6 form-group">
          <InputText
            label="Descripción"
            name="description"
            value={formValues?.description}
            onChange={(e) => handleChange('description', e.target.value)}
            placeholder="Ingrese la descripción"
            error={errors.description}
          />
        </div>
        <div className="col-md-12 form-group">
          <DropdownField
            label="Tipo de Cliente"
            name="client_type"
            value={formValues?.client_type}
            options={clientTypeOptions}
            onChange={(e) => handleChange('client_type', e.value)}
            placeholder="Seleccione el tipo de cliente"
            error={errors.client_type}
          />
        </div>
        <div className="col-12 form-group mt-3">
          {requestError &&
            <Alert variant="danger">
              {requestError?.response?.data?.message ||
               MODAL_FORM_ERRORS.CLIENT}
            </Alert>
          }
        </div>
      </div>
    </BaseModalForm>
  );
};

export default React.memo(EditClientModal);
